<div class="current-schedule-container" [ngClass]="getStatusClass(eventStatus)">
    <div class="current-schedule-body">
        <h1 class="insight-title">{{ eventName }}</h1>
        <p class="event-place">{{ eventPlace }}</p>
        <div class="current-schedule-details">
            <div class="details-item">
                <img src="/assets/img/dueDate.svg" alt="Due Date Icon" />
                <p>
                    Due: <span class="bold-text">{{ dueDate }} -</span> Last:
                    <span class="bold-text">{{ lastDate }}</span>
                </p>
            </div>
            <div class="details-item">
                <img
                    src="/assets/img/defaultPerson.svg"
                    alt="Assigned Person Icon"
                />
                <p>
                    Assigned to: <span class="bold-text">{{ assignedTo }}</span>
                </p>
            </div>
        </div>
    </div>
    <div
        class="event-status-badge"
        [ngClass]="getStatusBadgeClass(eventStatus)"
    >
        {{ eventStatus }}
    </div>
</div>
